type UrlParam = string | number | null | undefined;

/**
 * Replaces the `:param` segments of a path template with the matching values.
 * Commas stay literal because the `type` segment is a comma-separated list; a
 * missing value renders as an empty segment.
 */
export const createUrl = (template: string, params: Record<string, UrlParam>): string =>
  template.replace(/:(\w+)/g, (_match, key: string) => {
    const value = params[key];

    if (value === null || value === undefined) {
      return '';
    }

    return encodeURIComponent(String(value)).replaceAll('%2C', ',');
  });
